import { useEffect, useState } from "react";
import { List, X } from "@phosphor-icons/react";

const NAV_LINKS = [
  { href: "#opportunities", label: "Opportunities" },
  { href: "#investors", label: "Investors" },
  { href: "#businesses", label: "Goa Businesses" },
  { href: "#showcase", label: "Showcase" },
  { href: "#register", label: "Contact" },
];

export const Navigation = () => {
  const [open, setOpen] = useState(false);
  const [scrolled, setScrolled] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 40);
    onScroll();
    window.addEventListener("scroll", onScroll, { passive: true });
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  return (
    <header
      data-testid="site-nav"
      className={`fixed top-0 inset-x-0 z-50 transition-all duration-500 ${
        scrolled
          ? "backdrop-blur-2xl bg-[#02060D]/80 border-b border-white/5"
          : "bg-transparent"
      }`}
    >
      <div className="max-w-7xl mx-auto px-6 md:px-12 h-24 flex items-center justify-between">
        <a href="#top" data-testid="nav-logo" className="group flex items-center gap-3">
          <img
            src="https://customer-assets-39nsmqrw.emergentagent.net/job_goa-invest/artifacts/mrr3mszg_17F6A14A-42EB-47E8-9DD4-22DA51DBF45F.PNG"
            alt="CountGoa — Connecting Goa to the World"
            className="h-16 md:h-20 w-auto object-contain"
          />
        </a>

        <nav className="hidden lg:flex items-center gap-10">
          {NAV_LINKS.map((l) => (
            <a
              key={l.href}
              href={l.href}
              data-testid={`nav-link-${l.label.toLowerCase().replace(/\s/g, "-")}`}
              className="text-sm text-[#A1AEBF] hover:text-white transition-colors gs-underline"
            >
              {l.label}
            </a>
          ))}
        </nav>

        <div className="hidden lg:flex items-center gap-3">
          <a
            href="#register"
            data-testid="nav-explore-btn"
            className="text-sm px-5 py-2.5 border border-white/15 text-white hover:border-white/40 transition-colors"
          >
            Explore Opportunities
          </a>
          <a
            href="#register"
            data-testid="nav-register-btn"
            className="text-sm px-5 py-2.5 bg-[#D1B677] text-[#02060D] font-medium hover:bg-[#E6CC8A] transition-colors"
          >
            Register Free
          </a>
        </div>

        <button
          data-testid="nav-mobile-toggle"
          onClick={() => setOpen((v) => !v)}
          className="lg:hidden text-white p-2 -mr-2"
          aria-label="Toggle menu"
        >
          {open ? <X size={24} weight="light" /> : <List size={24} weight="light" />}
        </button>
      </div>

      {open && (
        <div className="lg:hidden bg-[#02060D]/95 backdrop-blur-2xl border-t border-white/5">
          <div className="px-6 py-6 flex flex-col gap-4">
            {NAV_LINKS.map((l) => (
              <a
                key={l.href}
                href={l.href}
                onClick={() => setOpen(false)}
                className="text-base text-[#A1AEBF] hover:text-white transition-colors"
                data-testid={`mobile-nav-link-${l.label.toLowerCase().replace(/\s/g, "-")}`}
              >
                {l.label}
              </a>
            ))}
            <a
              href="#register"
              onClick={() => setOpen(false)}
              data-testid="mobile-register-btn"
              className="mt-2 text-sm px-5 py-3 bg-[#D1B677] text-[#02060D] font-medium text-center"
            >
              Register Free
            </a>
          </div>
        </div>
      )}
    </header>
  );
};

export default Navigation;
